// extracted by mini-css-extract-plugin
module.exports = {"background":"Modal_background__27vNE"};